<template>
  <authenticated-layout>
    <div class="row">
      <div class="col-12">
        <scan-folheto-table />
      </div>
    </div>
  </authenticated-layout>
</template>

<script>
import AuthenticatedLayout from "@/components/AuthenticatedLayout.vue";
import ScanFolhetoTable from "./components/ScanFolhetoTable.vue";

export default {
  name: "ScanFolheto",
  components: {
    AuthenticatedLayout,
    ScanFolhetoTable,
  },
};
</script>
